<template>
  <Section title="Dane osoby zgłaszającej">
    <b-form novalidate>
      <div class="row user__actions" v-if="isAdmin && user.id && !user.isAdmin()">
        <div class="col-md-4">
          <div class="user-action__active">
            <btn
              v-if="!user.active && user.canActivate(currentUser)"
              variant="success"
              icon="user-check"
              title="Aktywuj"
              @click="activate"
            />&nbsp;Konto jest {{ user.active ? "aktywne" : "NIEAKTYWNE" }}
          </div>
          </div>
          <div class="col-md-4">
            <div class="user-action__block">
            <template v-if="user.active">
              <span v-if="user.blocked">
                <span v-if="user.blockeduntil">ZABLOKOWANE do {{user.blockeduntil}}</span>
                <span v-if="user.blockedafter">ZABLOKOWANE do {{user.blockedafter}}</span>
              </span>
              <span v-else>
                Konto jest odblokowane
              </span>
              <btn
                v-if="!user.blocked && user.canBlock(currentUser)"
                variant="danger"
                icon="lock"
                title="Zablokuj"
                @click="block"
              />
              <btn
                v-if="user.blocked && user.canUnblock(currentUser)"
                variant="success"
                icon="unlock"
                title="Odblokuj"
                @click="unblock"
              />
            </template>
            </div>
            </div>
            <div class="col-md-4">
              <div class="user-action__remove">
                Trwałe usunięcie konta
            <btn
              v-if="user.canRemove(currentUser)"
              variant="danger"
              icon="times"
              title="Usuń"
              @click="remove"
            />
            </div>
            </div>
        </div>
        <hr />
      </div>
      <form-wrapper :validator="$v.user">
        <form-group name="firstName">
          <template slot-scope="{validator}">
          <InputControl
            id="firstName"
            v-model="user.firstName"
            label="Imię"
            :inline="true"
            :label-class="labelClass"
            :control-class="controlClass"
            :description-class="descriptionClass"
            @input="touch(validator)"
          />
          </template>
        </form-group>

        <form-group name="lastName">
          <template slot-scope="{validator}">
          <InputControl
            id="lastName"
            v-model="user.lastName"
            label="Nazwisko"
            :inline="true"
            :label-class="labelClass"
            :control-class="controlClass"
            :description-class="descriptionClass"
            @input="touch(validator)"
          />
          </template>
        </form-group>

        <form-group name="email">
          <template slot-scope="{validator}">
          <InputControl
            id="email"
            v-model="user.email"
            label="Email"
            :inline="true"
            :label-class="labelClass"
            :control-class="controlClass"
            :description-class="descriptionClass"
            :disabled="user.id ? true : false"
            @input="touch(validator)"
          />
          </template>
        </form-group>

        <form-group name="phone">
          <template slot-scope="{validator}">
          <InputControl
            id="phone"
            v-model="user.phone"
            label="Telefon"
            :inline="true"
            :label-class="labelClass"
            :control-class="controlClass"
            :description-class="descriptionClass"
            @input="touch(validator)"
          />
          </template>
        </form-group>

        <CheckboxControl
          v-if="user.id"
          id="change-password"
          v-model="user.changePassword"
          label=""
          :options="[{ id: '1', name: 'Chcę zmienić hasło' }]"
          :inline="true"
        />

        <div v-if="user.changePassword || !user.id">
          <hr />

          <form-group name="password">
            <template slot-scope="{validator}">
            <InputControl
              id="password"
              v-model="user.password"
              label="Hasło"
              type="password"
              :inline="true"
              :label-class="labelClass"
              :control-class="controlClass"
              :description-class="descriptionClass"
              description="Hasło musi składać się z 8 znaków, w tym: minimum jedna wielka litera, jedna cyfra i jeden znak specjalny. "
              @input="touch(validator)"
            />
            </template>
          </form-group>

          <form-group name="passwordConfirm">
            <template slot-scope="{validator}">
            <InputControl
              id="passwordConfirm"
              v-model="user.passwordConfirm"
              label="Potwierdzenie hasła"
              type="password"
              :inline="true"
              :label-class="labelClass"
              :control-class="controlClass"
              :description-class="descriptionClass"
              @input="touch(validator)"
            />
            </template>
          </form-group>
        </div>

        <div >
          <hr />

          <form-group>
            
              <AgreementControlLeft
                id="acceptMarketing"
                v-model="user.acceptMarketing"
                label="Wyrażam zgodę na przesyłanie na podane przeze mnie dane kontaktowe informacji handlowej oraz wykorzystywanie tych danych dla celów marketingu bezpośredniego przez Izbę POLMED (np. przesyłanie na podany adres email informacji o szkoleniach z zakresu compliance organizowanych przez Izbę POLMED)."
                short-text=""
                
              />
            
          </form-group>

          <form-group name="accept">
            <template slot-scope="{ validator }">
              <AgreementControlLeft
                id="accept"
                v-model="user.accept"
                :label="`Oświadczam, że <span>zapoznałem</span> się i akceptuję <a href='${agreementUrl}' target='_blank'>regulamin strony</a> oraz <a href='${certificationAgreementUrl}' target='_blank'>regulamin oceny wydarzeń edukacyjnych</a>.`"
                :disabled="isAdmin"
                short-text=""
                @input="touch(validator)"
              />
            </template>
          </form-group>

          <p v-if="!isAdmin" style="padding-left: 2em; margin-top: 2em" class="col-md-10">
            Informujemy, że Państwa dane osobowe podane w ramach korzystania z
            niniejszej witryny będą przetwarzane przez Ogólnopolską Izbę
            Gospodarczą Wyrobów Medycznych „POLMED”, w celu założenia oraz
            umożliwienia Państwu korzystania z konta na witrynie oraz – w
            przypadku wypełnienia dodatkowego formularza – oceny zgłoszonego
            przez Państwa wydarzenia, a także zabezpieczenia ewentualnych
            roszczeń Izby POLMED. Więcej informacji w
            <a :href="privacyPolicyUrl" taget="_blank">Polityce Prywatności</a>.
          </p>
        </div>

        <hr />

        <p v-if="errorMessage" class="invalid-feedback d-block text-right">
          {{ errorMessage }}
        </p>

        <div class="row">
          <div class="col-md-6">
            <btn
              v-if="user.id && isCurrentUser"
              variant="link"
              icon="lock"
              title="Wyloguj się"
              @click="$router.push('logout')"
            />
          </div>
          <div class="col-md-6 text-right">
            <btn
              v-if="user.id "
              variant="primary"
              icon="check"
              title="Zapisz"
              :disabled="isSending"
              disabled-icon="polmed"
              disabled-title="Zapisuję"
              @click="submit()"
            />
            <btn
              v-if="!user.id"
              variant="primary"
              icon="angle-right"
              :icon-right="true"
              @click="submit()"
            >
              Przejdź dalej
            </btn>
          </div>
        </div>
      </form-wrapper>
    </b-form>
  </Section>
</template>

<script>
import BaseForm from "@/components/Base/Form/BaseForm";
import InputControl from "@/components/Controls/InputControl";
import CheckboxControl from "@/components/Controls/CheckboxControl";
import Section from "@/components/Elements/Section";
import AgreementControlLeft from "@/components/Controls/AgreementControlLeft";

import validations from "./validations";
import ModelFactory from "@/model/ModelFactory";

import ModalConfirm from "@/mixins/ModalConfirm";

import { mapGetters, mapState } from "vuex";

export default {
  name: "UserAccountForm",
  components: {
    InputControl,
    CheckboxControl,
    Section,
    AgreementControlLeft
  },
  extends: BaseForm,
  mixins: [ModalConfirm],
  validations,
  props: {
    value: {
      type: Object,
      default: () => ModelFactory.create("UserModel")
    }
  },

  data() {
    return {
      formUrl: `${process.env.VUE_APP_XHR_ROOT}user/account/`,
      labelClass: "col-form-label col-md-3 form__label",
      controlClass: "col-md-9 form__control",
      descriptionClass: "offset-md-3 col-md-9 form__control-description",
      user: this.value,
      formName: "user",
      changePassword: false
    };
  },

  computed: {
    stepComponent: function() {
      const componentName = this.stepComponentPrefix + this.currentStep;
      return this.$options.components[componentName]
        ? componentName
        : this.stepComponentPrefix;
    },
    ...mapState("User", { currentUser: "user" }),
    ...mapGetters("User", ["isAdmin", "isUser"]),
    isCurrentUser() {
      return this.user.id == this.$store.state.User.user.id;
    },
    privacyPolicyUrl() {
      return process.env.VUE_APP_PRIVACY_POLICY_URL;
    },
    agreementUrl() {
      return process.env.VUE_APP_AGREEMENT_URL;
    },
    certificationAgreementUrl() {
      return process.env.VUE_APP_CERTIFICATION_AGREEMENT_URL;
    }
  },

  watch: {
    value: {
      handler: function(newValue) {
        this[this.formName] = newValue;
      },
      deep: true
    },
    // 'user.id': {
    //   handler(newValue) {
    //     this.user.changePassword = newValue && newValue > 0 ? false : true;
    //   },
    //   immediate: true,
    // },
    // 'user.changePassword'(newValue) {
    // }
  },

  created() {
    this.getUser(this.$route.params.id);
  },

  methods: {
    touch(validator) {
      if (validator) {
        validator.$touch();
      }
    },
    afterSubmit(res) {
      if (res.data.success) {
        this.getUser(this.$route.params.id);
      }
    },

    getUser(userId) {
      this.$store.dispatch("Account/get", userId).then(() => {
        this.user = ModelFactory.create(
          "UserModel",
          this.$store.state.Account.account
        );
      });
    },

    activate() {
      this.$store
        .dispatch("Account/activate", {
          userId: this.user.id,
          active: true
        })
        .then(() => (this.user.active = true));
    },

    block() {
      this.$store
        .dispatch("Account/block", {
          userId: this.user.id,
          block: true
        })
        .then(res => (this.user.blocked = res.success));
    },

    unblock() {
      this.$store
        .dispatch("Account/block", {
          userId: this.user.id,
          block: false
        })
        .then(res => (this.user.blocked = res.success));
    },

    remove() {
      let h = this.$createElement;
      let msg = [
        h("p", "Czy na pewno usunąć użytkownika"),
        h("p", [h("strong", `${this.user.username}?`)]),
        h(
          "p",
          "Usunięcie konta jest nieodwracalne. Dane użytkownika zostaną trwale zanonimizowane."
        )
      ];

      this.deleteDialog(msg).then(confirm => {
        if (confirm) {
          this.$store
            .dispatch("Account/remove", this.user.id)
            .then(() => this.$router.push("/accounts/"));
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/_variables';

.user__actions {
  
}

.user-action__active,
.user-action__block,
.user-action__remove {
  background: $col-polmed-gray;
  padding: 0 0 0 1.25rem;
  height: 38px;
  line-height: 38px;
  .btn {
    float: right;
  }
}
</style>
